export default __webpack_public_path__ + "static/media/ErikaMoyaUX.a945cb9c.pdf";